import './ModalCustomLegend.scss';
import { ColorKey } from '@Components/Charts/ChartTooltip/ChartTooltipV2';
import { LegendSection, PacingDetailSeries, PacingDetailSeriesPairs } from '../pacing-constants';
import { isPacingRatioGoalType } from '../pacingUtils';

interface ModalCustomLegendProps {
  graphView?: boolean;
  goalName?: string;
}

export const ModalCustomLegend = ({ graphView, goalName = '' }: ModalCustomLegendProps) => {
  const isMetricGoal = isPacingRatioGoalType(goalName);
  const { Actual, Projected } = PacingDetailSeriesPairs[graphView ? 'cumulative' : 'daily'];

  // Ratio goals only chart actuals (no projection or ideal); the budget line is cumulative-only.
  const sections: LegendSection[] = [
    {
      title: 'Actual Delivery',
      items: [
        { label: 'Actual', series: Actual[0] },
        ...(isMetricGoal ? [] : [{ label: 'Projected', series: Projected[0] }])
      ]
    },
    ...(isMetricGoal
      ? []
      : [
          {
            title: 'Ideal Delivery',
            items: [
              { label: 'Actual', series: Actual[1] },
              { label: 'Projected', series: Projected[1] }
            ]
          }
        ]),
    ...(graphView
      ? [{ title: 'Budget', items: [{ label: 'Budget', series: 'budget' as const }] }]
      : [])
  ];

  return (
    <div className='pacing-modal-legend'>
      {sections.map(({ title, items }) => (
        <div key={title} className='modal-legend-section'>
          <div className='modal-legend-title'>{title}</div>
          {items.map(({ label, series }) => (
            <div key={series} className='modal-items'>
              <ColorKey
                shape={PacingDetailSeries[series].shape}
                color={PacingDetailSeries[series].color}
              />
              <div className='modal-label'>{label}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
